import { StatusChip } from '@/components/status-chip'
import { edit } from '@/router/utils'
import { EditButton } from '@/shared/components/action-buttons'
import { Pagination } from '@/shared/components/pagination'
import { useGetOfficesQuery } from '@/store/services'
import { Typography } from '@material-tailwind/react'
import { HasAccess } from '@permify/react-role'
import { usePagination } from '@table-library/react-table-library/pagination'
import {
  Body,
  Cell,
  Header,
  HeaderCell,
  HeaderRow,
  Row,
  Table
} from '@table-library/react-table-library/table'
import { useTheme } from '@table-library/react-table-library/theme'
import { Link, useSearchParams } from 'react-router-dom'

const officeAddressLines = (address) => {
  const officeAddress = address || {}

  return [
    officeAddress.street,
    officeAddress.commune || officeAddress.state?.name,
    officeAddress.region || officeAddress.state?.city?.name
  ].filter(Boolean)
}

export const OfficeTable = () => {
  const { data: { offices = [], meta = {} } = {} } = useGetOfficesQuery(location.search, { skip: !location.search })
  const [searchParams, setSearchParams] = useSearchParams()

  const nodes = { nodes: offices }
  const onPaginationChange = (_, state) => {
    const page = state.page + 1
    const perPage = searchParams.get('per_page')

    searchParams.set('page', page)
    searchParams.set('per_page', perPage)
    setSearchParams(searchParams)
  }
  const pagination = usePagination(
    nodes,
    {
      state: {
        page: searchParams.get('page') - 1 || 0,
        size: searchParams.get('per_page') || 10
      },
      onChange: onPaginationChange
    },
    {
      isServer: true
    }
  )
  const chipOptions = {
    active: 'green',
    inactive: 'red'
  }

  const theme = useTheme({
    Table: `
      --data-table-library_grid-template-columns: 1fr 2fr 1fr 1fr 1fr 1fr ;
    `,
    BaseCell: `
      &:nth-of-type(6) {
        right: 0px;
      }
    `
  })
  return (

    <div className='flex flex-col justify-between gap-4 h-full'>
      <Table
        data={nodes}
        pagination={pagination}
        className='h-max'
        layout={{ custom: true, fixedHeader: true }}
        theme={theme}
      >
        {(tableList) => (
          <>
            <Header>
              <HeaderRow>
                <HeaderCell>Nombre</HeaderCell>
                <HeaderCell>Dirección</HeaderCell>
                <HeaderCell>Contratos</HeaderCell>
                <HeaderCell>Estado</HeaderCell>
                <HeaderCell>Datos del responsable</HeaderCell>
                <HeaderCell pinRight>Acciones</HeaderCell>
              </HeaderRow>
            </Header>

            <Body>
              {tableList.map(
                ({
                  id,
                  name,
                  status,
                  address,
                  personInCharge,
                  contractsCount
                }) => (
                  <Row key={id} item={id}>
                    <Cell>{name}</Cell>
                    <Cell>
                      <div className='flex flex-col items-start justify-center text-sm'>
                        {officeAddressLines(address).map((line, index) => (
                          <Typography
                            key={`${line}-${index}`}
                            variant='small'
                            color='gray'
                            className='text-gray-500'
                          >
                            {line}
                          </Typography>
                        ))}
                      </div>
                    </Cell>
                    <Cell>{contractsCount}</Cell>
                    <Cell>
                      <StatusChip value={status} options={chipOptions} />
                    </Cell>

                    <Cell>
                      <div className='flex flex-col items-start justify-center text-sm'>
                        <Typography
                          variant='small'
                          color='gray'
                          className='text-gray-500'
                        >
                          {personInCharge.full_name}
                        </Typography>
                        <Typography
                          variant='small'
                          color='gray'
                          className='text-gray-500'
                        >
                          {personInCharge.email}
                        </Typography>
                      </div>
                    </Cell>

                    <Cell pinRight>
                      <div className='flex gap-3'>
                        <HasAccess permissions={['office#edit']}>
                          <Link to={edit('offices', id)}>
                            <EditButton />
                          </Link>
                        </HasAccess>
                      </div>
                    </Cell>
                  </Row>
                )
              )}
            </Body>
          </>
        )}
      </Table>

      <Pagination
        onPageChange={({ selected }) => pagination.fns.onSetPage(selected)}
        page={pagination.state.page}
        totalPage={meta?.pagination?.total_pages}
      />
    </div>
  )
}
